



















import { Component, Vue } from 'vue-property-decorator';
import { routes } from '@/static/routes';
import { LinkButton, Paragraph } from '@/components/Base';
import { Box, HeroImageWrapper } from '@/components/Shared';

@Component({
  components: {
    Box,
    LinkButton,
    Paragraph,
    HeroImageWrapper,
  },
})
export default class NotFound extends Vue {
  public routes = routes;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/NotFound/NotFound.vue